const isNonProduction = process.env.NODE_ENV !== 'production';
const API_URL = 'https://kcplaa.mommoss.com';

export const path = isNonProduction
  ? {
      api: API_URL,
      socket: 'ws://192.168.10.178:3002',
    }
  : {
      api: API_URL,
      socket: 'ws://3.34.96.18:3000',
    };
